export const en = {
  meta: {
    locale: 'en',
  },
  igaGeonorge: {
    data: {
      users: {
        'ingrid-solberg': {
          role: 'GIS adviser',
          department: 'Agency for Planning and Building Services',
        },
        'marius-lunde': {
          role: 'Data steward',
          department: 'Agency for Urban Environment',
        },
        'sara-holm': {
          role: 'External project manager',
          department: 'Water and Wastewater Agency',
        },
        'erik-nordli': {
          role: 'Access manager',
          department: 'Agency for Improvement and Development',
        },
        'amalie-berg': {
          role: 'Map data analyst',
          department: 'Agency for Planning and Building Services',
        },
        'jonas-haugen': {
          role: 'Case officer',
          department: 'Agency for Real Estate and Urban Renewal',
        },
        'fatima-ali': {
          role: 'Integration lead',
          department: 'Oslo Origo',
        },
        'anders-moen': {
          role: 'System owner',
          department: 'Agency for Urban Environment',
        },
        'karoline-dahl': {
          role: 'Architect',
          department: 'Agency for Planning and Building Services',
        },
        'thomas-ruud': {
          role: 'Facilities coordinator',
          department: 'Oslobygg KF',
        },
        'nora-aas': {
          role: 'Environmental data owner',
          department: 'Climate Agency',
        },
        'martin-eide': {
          role: 'Project manager',
          department: 'Waste Management and Recycling Agency',
        },
        'silje-bakken': {
          role: 'Specialist adviser',
          department: 'Education Agency',
        },
        'hassan-hussain': {
          role: 'Municipal data sharer',
          department: 'Agency for Health',
        },
        'eline-vik': {
          role: 'Procurement adviser',
          department: 'Agency for Improvement and Development',
        },
        'ola-mathisen': {
          role: 'Building case officer',
          department: 'Agency for Planning and Building Services',
        },
        'maria-nguyen': {
          role: 'Geodata coordinator',
          department: 'Borough Grunerlokka',
        },
        'per-nygaard': {
          role: 'Emergency preparedness analyst',
          department: 'Fire and Rescue Service',
        },
        'lina-johansen': {
          role: 'Digital library developer',
          department: 'Deichman Library',
        },
        'emil-kristoffersen': {
          role: 'Legal adviser',
          department: 'Office of the City Advocate',
        },
        'sana-khan': {
          role: 'Service designer',
          department: 'Agency for Welfare',
        },
        'bjorn-larsen': {
          role: 'Network administrator',
          department: 'City of Oslo ICT',
        },
        'ida-myrvang': {
          role: 'Portfolio lead',
          department: 'Department of Urban Development',
        },
        'christian-holmboe': {
          role: 'Data engineer',
          department: 'Oslo Origo',
        },
        'tuva-lie': {
          role: 'HR system administrator',
          department: 'Governing Mayor Office',
        },
        'magnus-strand': {
          role: 'GIS operator',
          department: 'Agency for Urban Environment',
        },
        'anne-wold': {
          role: 'Records officer',
          department: 'Agency for Cultural Affairs',
        },
        'mohamed-yusuf': {
          role: 'Security coordinator',
          department: 'Nursing Home Agency',
        },
        'ragnhild-sveen': {
          role: 'Section manager',
          department: 'Borough Gamle Oslo',
        },
        'petter-hansen': {
          role: 'Data catalog manager',
          department: 'Agency for Planning and Building Services',
        },
        'camilla-nilsen': {
          role: 'Test lead',
          department: 'Agency for Improvement and Development',
        },
        'henrik-iversen': {
          role: 'Entra administrator',
          department: 'City of Oslo ICT',
        },
        'solveig-rustad': {
          role: 'Information architect',
          department: 'City Archives',
        },
        'daniel-bergum': {
          role: 'API manager',
          department: 'Oslo Origo',
        },
        'emma-sorensen': {
          role: 'Project controller',
          department: 'Water and Wastewater Agency',
        },
      },
      right: {
        title: 'Sensitive infrastructure Oslo',
        shortTitle: 'Sensitive infrastructure Oslo',
        datasetName: 'Sensitive infrastructure - City of Oslo',
        accessLevel: 'Restricted-access data',
        description: 'Administrative entitlement to a restricted map layer via Geonorge.',
      },
      datasets: {
        'fkb-bygning-tiltak': {
          name: 'FKB Buildings and Building Measures',
          description: 'Buildings, measures, and building-related map data.',
        },
        eiendomsgrenser: {
          name: 'Property boundaries',
          description: 'Cadastral boundaries and property references.',
        },
        'va-ledningsdata': {
          name: 'Water/wastewater network data',
          description: 'Pipe networks and technical water infrastructure.',
        },
        'sarbar-infrastruktur': {
          name: 'Sensitive infrastructure',
          description: 'Restricted infrastructure layer for preparedness and secure municipal administration.',
        },
      },
      districts: {
        oslo: 'City of Oslo',
        'bydel-gamle-oslo': 'Borough Gamle Oslo',
        'bydel-grunerlokka': 'Borough Grunerlokka',
        'bydel-sagene': 'Borough Sagene',
        'bydel-stovner': 'Borough Stovner',
        'bydel-nordre-aker': 'Borough Nordre Aker',
      },
      actions: {
        read: 'View',
        download: 'Download',
        edit: 'Edit',
        'read-download': 'View, download',
      },
      assurance: {
        normal: 'Normal',
        high: 'Assurance level HIGH',
      },
      targets: {
        entra: 'Microsoft Entra ID',
        wallet: 'Digital wallet (EUDI)',
      },
    },
    shell: {
      tenant: 'City of Oslo IDA',
      requestManagement: 'Access request',
    },
    credential: {
      holder: 'Holder',
      pid: 'PID',
      right: 'Entitlement',
      dataset: 'Data type',
      area: 'Area',
      action: 'Action',
      assurance: 'Assurance level',
      validUntil: 'Valid until',
      status: 'Status',
      revoked: 'Revoked',
      active: 'Active credential',
      missing: 'Missing',
      revokedSuffix: 'revoked',
    },
    admin: {
      eyebrow: 'Identity Governance',
      title: 'Identity governance',
      phases: {
        creatingProof: 'Issue wallet credential',
        informingUser: 'Notify employee',
        done: 'Decision saved',
      },
      openWallet: 'Open wallet',
      activeCredential: 'Credential active',
      steps: {
        employee: 'Select identity',
        action: 'Choose entitlement type',
        right: 'Specify entitlement',
        provisioning: 'Storage',
      },
      actionChoices: {
        grant: {
          title: 'GeoNorge administrative entitlement',
          description: 'Delegate access to the Sensitive infrastructure map layer for a selected borough.',
        },
        modify: {
          title: 'Modify access',
          description: 'Change the selected employee’s active demo entitlement.',
          unavailable: 'No existing demo access',
        },
        revoke: {
          title: 'End access',
          description: 'Remove active Entra assignment and revoke any wallet credential.',
          unavailable: 'No active access to end',
        },
      },
      entitlementCatalog: {
        geonorge: {
          title: 'Sensitive infrastructure',
          description: 'Administrative entitlement for map layer, area, and actions.',
        },
        matrikkel: {
          title: 'Cadastre data',
          description: 'Property, building, and address data for municipal casework.',
        },
        planregister: {
          title: 'Planning register',
          description: 'Plan status, zoning, and land-use rights for internal processes.',
        },
        byggesak: {
          title: 'Building casework',
          description: 'Rights connected to building-case workflows and decision records.',
        },
        beredskap: {
          title: 'Emergency data',
          description: 'Protected access to datasets used in incidents and exercises.',
        },
      },
      noIdentityTitle: 'No identity selected',
      noIdentityBody: 'Select an identity from the directory to evaluate access.',
      storage: {
        entraDescription: 'Group assignment for internal access control.',
        entraHighUnavailable: 'Entra cannot provide Assurance level HIGH.',
        walletDescription: 'Issue an entitlement credential to the employee.',
        notifyDescription: 'Send the decision and any wallet offer to the employee.',
        chooseAtLeastOne: 'Select at least one storage target',
      },
      provisioning: {
        assignEntra: 'Assign Entra ID group',
        issueWallet: 'Issue wallet credential',
        notifyEmployee: 'Notify employee',
      },
      scope: {
        dataset: 'Data type',
        area: 'Borough',
        action: 'Action',
        assurance: 'Assurance level',
        demoOnly: 'Demo',
        highWalletNotice:
          'Digital wallet is required because Entra cannot provide Assurance level HIGH. When the entitlement is used, the wallet shares PID together with the entitlement credential.',
        assuranceHelp: {
          normal: 'Standard access can be stored in Entra or wallet.',
          high: 'Wallet is required because this data type needs Assurance level HIGH when used.',
        },
      },
      details: 'Details',
      assignAccess: 'Save and issue entitlement',
      saveChanges: 'Save changes',
      saveAccess: 'Save entitlement',
      removeUser: 'Remove user - employment ended',
      popupBlocked: 'Allow popups, or open the wallet from the demo controls in the header.',
      selectedAccess: 'Selected access',
      employeeCount: '{count} employee identities',
      employeeDemoCount: '{count} in directory sample',
      status: 'Status',
      employee: 'Employee',
      right: 'Entitlement',
      revokeSummary: 'This will end the active demo entitlement for {name}.',
      accessEnded: 'Access ended',
      assigned: 'Assigned',
      readyToSave: 'Ready to save',
      endAccess: 'End access',
      launcher: 'Demo launcher',
      resetScenario: 'Reset scenario',
      walletLink: 'Symfoni ID wallet',
      geonorgeLink: 'Geonorge',
    },
    audit: {
      ready: 'Request is ready for decision.',
      approved: '{time} Request approved for {name}. Targets: {targets}.',
      offerQueued: '{time} External credential offer queued for recipient.',
      credentialAccepted: '{time} {name} accepted the credential after mock ID-porten login.',
      deprovisioned: '{time} {name} deprovisioned: {artifacts}.',
      revocationReason: '{name} is marked as no longer employed in IGA.',
      artifacts: {
        entraRemoved: 'Microsoft Entra group removed',
        offerCanceled: 'external credential offer canceled',
        credentialRevoked: 'external credential revoked',
        none: 'no active entitlement found',
      },
    },
    wallet: {
      title: 'Symfoni ID personal wallet',
      subtitle: 'Mock EUDI wallet',
      offersTitle: 'New offers',
      emptyTitle: 'No new credentials',
      emptyBody: 'You have no new offers to handle.',
      newOffer: 'New credential offered',
      offerBody: 'The City of Oslo offers {name} an administrative credential for Geonorge.',
      issuer: 'Issuer',
      issuerName: 'City of Oslo IDA',
      receiveCredential: 'Receive credential',
      idPortenTitle: 'ID-porten login',
      idPortenSubtitle: 'Mock issuer authentication',
      idPortenHighSubtitle: 'Mock issuer authentication',
      person: 'Person',
      completeLogin: 'Complete login',
      issuing: 'Retrieving credential from issuer...',
      myCredentials: 'My credentials',
      pidCredential: {
        title: 'PID',
        description: 'Person identity ready to share for high-assurance use.',
      },
      employeeCredential: {
        title: 'City of Oslo employee credential',
        description: 'Confirms active employment and municipal role.',
        role: 'Role',
        department: 'Agency',
        employer: 'Employer',
        employerName: 'City of Oslo',
        active: 'Active employment',
      },
    },
    walletShare: {
      title: 'Symfoni ID',
      subtitle: 'Geonorge requests PID and entitlement credential',
      heading: 'Share with Mock Geonorge',
      body: 'The wallet shares PID for Assurance level HIGH and the administrative credential for {right}.',
      pid: 'PID (Assurance level HIGH)',
      credential: 'Credential',
      revokedWarning:
        'The credential is marked as revoked, but can still be presented for a negative demo.',
      share: 'Share PID and credential',
      shared: 'The presentation has been sent to Geonorge.',
    },
    geonorge: {
      search: 'Search Geonorge',
      menu: 'Menu',
      breadcrumbCatalog: 'Map catalog',
      breadcrumbLayer: 'Map layer',
      title: 'Sensitive infrastructure',
      info1: 'The layer shows restricted infrastructure for the selected administrative area.',
      info2: 'The base map is open. The sensitive layer requires a wallet-based presentation of PID and entitlement credential.',
      info3: 'After an approved presentation, the layer appears as an overlay on the map.',
      readMore: 'Read more about restricted map layers',
      accessStatusTitle: 'Access status',
      goHome: 'Go to start',
      removeDataset: 'Remove dataset',
      status: {
        processing: 'Checking access...',
        approved: 'Sensitive infrastructure layer is active',
        denied: 'You do not have access to this dataset.',
        idle: 'Sign in to view restricted map layers.',
      },
      popupBlocked: 'Allow popups, or open `/wallet/share` in a separate tab.',
      loginWithWallet: 'Sign in with wallet',
      map: {
        title: 'Geonorge map surface for Sensitive infrastructure',
        baseMap: 'Base map',
        sensitiveLayer: 'Sensitive infrastructure layer',
        lockedLayer: 'Locked sensitive layer',
        lockedBody: 'Present the wallet credential to show Sensitive infrastructure for the selected area.',
        visibleLayer: 'Sensitive infrastructure visible',
        oslo: 'Oslo',
      },
      panel: {
        statusTitle: 'Layer status',
        area: 'Area',
        layer: 'Map layer',
        rights: 'Delegated rights',
        managementTitle: 'Administration',
        managementBody: 'Edit is shown as a delegated right when selected in IDA, but this demo does not implement edit mode.',
      },
      version: 'Version 14.5.2563',
      about: 'About the website',
      aboutItems: ['About Geonorge', 'Privacy and use of cookies', 'Accessibility statement'],
      contact: 'Contact',
      phone: 'Phone: 32 11 80 00',
      organizationNumber: 'Org. no.: 971 040 238',
    },
    verification: {
      missingCredential: 'No Geonorge entitlement was shared from the wallet.',
      pidMismatch: 'The PID in the presentation does not match the credential holder.',
      wrongDataset: 'The credential is not for the requested Geonorge dataset.',
      insufficientAssurance: 'This data type requires Assurance level HIGH.',
      revoked: 'The credential has been revoked by the City of Oslo IGA.',
      expired: 'The credential has expired.',
      approved: 'PID and entitlement credential are verified.',
    },
  },
} as const;
